import { apiUrl } from "utils/apiUrl";
import { clientSafeMessage } from "utils/clientSafeMessage";

export async function pushCopySettingsToDuplikium({
  slot,
  riskManagement,
  riskValue,
  copyOn = true,
}) {
  const res = await fetch(apiUrl("/api/client/copy-update-slave-copy"), {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      slot,
      riskManagement,
      riskValue,
      copyOn,
    }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.ok) {
    throw new Error(
      clientSafeMessage(data.message, "Could not save your risk settings."),
    );
  }
  return data;
}
